import React from 'react';
import { format } from 'date-fns';

import About from 'components/Meteorology/Agro/WaterBalanceCulture/About';
import DVCardMobileLayout from 'components/Meteorology/Agro/WaterBalanceShared/DVCardMobileLayout';
import useDetailedViewMobile from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/Mobile/useDetailedViewMobile';
import { formatRunDateChip } from 'helper/Meteorology/Agro/chartSubtitle';
import DVChart from '../DVChart';
import ControlPanelSheet from './ControlPanelSheet';
import EmptyState from './EmptyState';
import FullscreenChart from './FullscreenChart';

const COMPONENTS = {
  Chart: DVChart,
  Fullscreen: FullscreenChart,
  About,
  ControlPanelSheet,
  EmptyState,
};

export default function DVCardMobile() {
  const {
    location, culture, emergency, period, soil, chartVariable, params,
    graphData, runDate, graphDataLoading, queryError, onRetry,
  } = useDetailedViewMobile();

  const selectedLocationName = location.availableLocations
    .find((l) => l.id === location.selectedLocation)?.name;
  const selectedCultureLabel = culture.availableCultures
    ?.find((c) => c.id === culture.selectedCulture)?.label;
  const selectedSoilLabel = soil.soilTypes?.find((s) => s.id === soil.selectedSoil)?.label;

  const chips: string[] = [];
  if (selectedCultureLabel) chips.push(selectedCultureLabel);
  if (emergency.emergencyDate) chips.push(`Emergência: ${format(emergency.emergencyDate, 'dd/MM/yy')}`);
  if (period.startDate && period.endDate) {
    chips.push(`${format(period.startDate, 'dd/MM/yy')} – ${format(period.endDate, 'dd/MM/yy')}`);
  }
  // #2009: a rodada da previsão usada no cálculo; ausente em consulta só histórica.
  const runChip = formatRunDateChip(runDate);
  if (runChip) chips.push(runChip);
  if (selectedSoilLabel) chips.push(`Solo: ${selectedSoilLabel}`);

  return (
    <DVCardMobileLayout
      optionKey="name"
      title={selectedLocationName}
      chips={chips}
      filenamePrefix="balanco_hidrico_cultura"
      emptyText="Defina grupo, local, cultura e data de emergência no painel de controle para visualizar o balanço hídrico da cultura."
      graphData={graphData}
      graphDataLoading={graphDataLoading}
      hasParams={params !== undefined}
      queryError={queryError}
      onRetry={onRetry}
      chartVariable={chartVariable}
      period={period}
      components={COMPONENTS}
    />
  );
}
